module.exports = __webpack_public_path__ + "static/media/Mobile Payment.bc8e8a60.svg";